import React, { Component } from "react";

import { checkUndefine } from "../../../../../../helpers/functions";
import DEFINE, { DETAIL_ACTIONS, UPLOAD_DIRECTORY } from "../../../../../../constants/Define";
import {
  FormWrapperItem,
  FormWrapperInputComponent,
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import UploadImage from "../../../../common/component/UploadImage";
import Wrapper from "../../../../common/component/Wrapper";
import RichTextEditor, {
  ClassicEditor,
} from "../../../../common/component/RichTextEditor";

import { find, groupBy, toArray } from "lodash";
import "./SupplierInfo.less";
import AntSelect, { AntOptGroup, AntOption } from "../../../../common/component/AntSelect";
import Switch from "../../../../common/component/Switch";
import * as Func from "../../../../../../helpers/functions";
import { Icon, message, Popover } from "antd";
import Button from "../../../../common/component/Button";
import DatePicker from "react-multi-date-picker";
import Radio from "../../../../common/component/Radio";
import { SUPPLIER, DATE_TIME_FORMAT, ENUM_SUPPLIER_SALE_DATE_TYPE, SUPPLIER_CATEGORY } from '../../../../../../constants/Define';
import { DatePickerComponent } from "../../../../common/component/Index"
import { getProperties } from "../../../../../../services/fnbService";


export default class SupplierInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteCodePopoverContent: null,
      supplierSystem: null,
      errorAddFAQs: { question: "", answer: "", addFAQs: [] },
      originalTypeValues: null,
      fnbProperties: [],
      isUploadingLogoImage: false,
    };
  }

  componentDidMount() {
    let contentPopoverSiteCode = <i>Bạn chưa chọn Sitecode</i>;
    this.setState({
      supplierSystem: SUPPLIER_CATEGORY.SUPPLIER_TYPE.VINWONDER.id,
      siteCodePopoverContent: contentPopoverSiteCode,
      originalTypeValues: {
        [this.props.supplier.saleDateType]: this.props.supplier.saleDateValues,
      },
    });

    this.fetchFnbProperties();
  }

  componentDidUpdate(prevProps, prevState) {
    this.getSitesBySupplier(prevState);
    this.setInitalContentPopover(prevProps);

    if (prevProps.supplier.saleDateType !== this.props.supplier.saleDateType) {
      this.setState(prevState => ({
        originalTypeValues: {
          ...prevState.originalTypeValues,
          [this.props.supplier.saleDateType]: this.props.supplier.saleDateValues
        }
      }));
    }

    if (!prevProps.updateSuccess && this.props.updateSuccess) {
      this.setState({
        originalTypeValues: {
          [this.props.supplier.saleDateType]: this.props.supplier.saleDateValues
        }
      });
    }

    if (
      prevProps.uploadState !== this.props.uploadState &&
      !this.props.uploadState?.isFetching &&
      !this.props.uploadState?.isFetchingMultiple
    ) {
      this.setState({ isUploadingLogoImage: false });
    }
  }

  setInitalContentPopover = (prevProps) => {
    if (this.props.sites.length !== prevProps.sites.length || this.props.supplier.propertyCode !== prevProps.supplier.propertyCode) {
      const site = this.props.sites.find((item) => item.propertyCode === this.props.supplier.propertyCode);
      const content = site ? <span><b>{`Sitecode: ${site.code} - ${site.name}`}</b><br />{`${site.propertyCode} - ${site.propertyName}`}</span> : <i>Bạn chưa chọn Sitecode</i>;
      this.setState({
        siteCodePopoverContent: content,
      });
    }
  };

  getSitesBySupplier = (prevState) => {
    if (this.state.supplierSystem !== prevState.supplierSystem) {
      switch (this.state.supplierSystem) {
        case SUPPLIER_CATEGORY.SUPPLIER_TYPE.VINWONDER.id:
          this.props.onGetVinWonderSites();
          break;
        default:
          break;
      }
    }
  };

  getSelectOptionText = (children) => {
    if (children === null || children === undefined) {
      return "";
    }

    if (typeof children === "string" || typeof children === "number") {
      return children.toString();
    }

    if (Array.isArray(children)) {
      return children.map(this.getSelectOptionText).join(" ");
    }

    if (React.isValidElement(children)) {
      return this.getSelectOptionText(children.props.children);
    }

    return "";
  };

  selectFilterSearchAnt = (input, option) => {
    const optionText = Func.vietnameseStringToUnicode(
      this.getSelectOptionText(option?.props?.children).toLowerCase()
    );
    const inputText = Func.vietnameseStringToUnicode((input || "").toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };

  getSupplierType = () => {
    return toArray(SUPPLIER_CATEGORY.SUPPLIER_TYPE);
  };

  renderOptionsSiteSelect = () => {
    const { sites } = this.props;

    const groupSites = groupBy(
      sites,
      (item) => `Sitecode: ${item.code} - ${item.name}`
    );
    return Object.keys(groupSites || {}).map((key) => {
      return (
        <AntOptGroup key={key} label={`${key}`}>
          {(groupSites[key] || []).map((item) => (
            <AntOption
              key={`site-${item.code}-option-${item.propertyCode}`}
              value={item.propertyCode}
            >
              {`${item.propertyCode} - ${item.propertyName}`}
            </AntOption>
          ))}
        </AntOptGroup>
      );
    });
  };
  onChangeContentPopoverSiteCode = (siteCode) => {
    const site = this.props.sites.find((item) => item.propertyCode === siteCode);
    const content = site ? <span><b>{`Sitecode: ${site.code} - ${site.name}`}</b><br />{`${site.propertyCode} - ${site.propertyName}`}</span> : <i>Bạn chưa chọn Sitecode</i>;
    this.setState({
      siteCodePopoverContent: content,
    });
    this.props.onChange("siteCode", site.code || undefined);
    this.props.onChange("propertyCode", site.propertyCode || undefined);
  }

  // Helper function to format dates as dd/mm/yyyy
  formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  renderDatePicker = () => {
    const { supplier, t, action } = this.props;

    const handleDateChange = (dates) => {
      const parsedDates = Array.isArray(dates) ? dates.map(this.formatDate) : [];
      this.props.onChange("saleDateValues", parsedDates);

      this.setState(prevState => ({
        originalTypeValues: {
          ...prevState.originalTypeValues,
          [supplier.saleDateType]: parsedDates
        }
      }));
    };

    const originalValue = this.state.originalTypeValues?.[supplier.saleDateType];

    return (
      <>
        {ENUM_SUPPLIER_SALE_DATE_TYPE.MULTIPLE === supplier.saleDateType && (
          <DatePicker
            multiple
            value={originalValue || [new Date()]}
            onChange={handleDateChange}
            format={DATE_TIME_FORMAT.SHORT_DATE}
            minDate={new Date(new Date().setHours(0, 0, 0, 0))}
            style={{
              backgroundColor: "aliceblue",
              height: "40px",
              borderRadius: "8px",
              fontSize: "14px",
              padding: "3px 10px",
              width: "400px",
            }}
          />
        )}
        {ENUM_SUPPLIER_SALE_DATE_TYPE.RANGE === supplier.saleDateType && (
          <DatePicker
            range
            value={originalValue || [new Date(), new Date()]}
            onChange={handleDateChange}
            format={DATE_TIME_FORMAT.SHORT_DATE}
            minDate={new Date(new Date().setHours(0, 0, 0, 0))}
            style={{
              backgroundColor: "aliceblue",
              height: "40px",
              borderRadius: "8px",
              fontSize: "14px",
              padding: "3px 10px",
              width: "400px",
            }}
          />
        )}
      </>
    );
  };

  fetchFnbProperties = () => {
    getProperties({ limit: 1000, offset: 0 })
      .then((response) => {
        const fnbProperties = response || [];
        this.setState({ fnbProperties });
      })
      .catch(() => {
        this.setState({ fnbProperties: [] });
      });
  };

  render() {
    const { t, supplier, validation, uploading, action, supplierFAQs } = this.props;
    const { fnbProperties } = this.state;

    return (
      <Wrapper className="supplier-info-section">
        <FormWrapperItem>
          <Wrapper className="col-md-12 row m-0 p-0 pl-3 pr-3">
            <Wrapper className="col-md-4 m-0 p-0 pt-2">
              <UploadImage
                multiple={false}
                loading={uploading}
                thumbnailSize={"100%"}
                thumbnailStyle={{ maxHeight: 200 }}
                buttonSize={150}
                disabledUpload={action === DETAIL_ACTIONS.TRANSLATE}
                disabledRemove={action === DETAIL_ACTIONS.TRANSLATE}
                uploadText={t("item.supplier.logo")}
                loadingText={t("item.supplier.uploading")}
                onChange={this.props.onUploadImage}
                onRemoveThumbnail={this.props.onRemoveImage}
                thumbnails={
                  supplier.logo && this.getThumbSources([supplier.logo])
                }
              />
            </Wrapper>
            <Wrapper className="col-md-8 row m-0 p-0 pl-md-2">
              <Wrapper className="col-md-12 m-0 p-0">
                <FormWrapperInputComponent
                  isRequired={true}
                  isValidation={true}
                  dataValidation={supplier.supplierName}
                  validation={validation.supplierName}
                  labelTitle={t(`item.supplier.supplierName`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Input
                    placeholder=""
                    type={`text`}
                    className={`form-control`}
                    name={`supplierName`}
                    onChange={(e) =>
                      this.props.onChange("supplierName", e.target.value)
                    }
                    value={checkUndefine(supplier.supplierName)}
                  />
                </FormWrapperInputComponent>
              </Wrapper>
              <Wrapper className="col-md-12 m-0 p-0">
                <FormWrapperInputComponent
                  isValidation={true}
                  dataValidation={supplier.email}
                  validation={validation.email}
                  labelTitle={t(`item.supplier.email`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Input
                    placeholder=""
                    type={`text`}
                    className={`form-control`}
                    name={`email`}
                    onChange={(e) =>
                      this.props.onChange("email", e.target.value)
                    }
                    value={checkUndefine(supplier.email)}
                  />
                </FormWrapperInputComponent>
              </Wrapper>
            </Wrapper>
          </Wrapper>
          <Wrapper className="col-md-12 row m-0 p-0 pl-3 pr-3">
            <Wrapper className="col-md-12 m-0 p-0">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.address`)}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`address`}
                  onChange={(e) =>
                    this.props.onChange("address", e.target.value)
                  }
                  value={checkUndefine(supplier.address)}
                />
              </FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6 m-0 p-0 pr-2">
              <FormWrapperInputComponent
                isValidation={true}
                dataValidation={supplier.phoneNumber}
                validation={validation.phoneNumber}
                labelTitle={t(`item.supplier.phoneNumber`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`phoneNumber`}
                  onChange={(e) =>
                    this.props.onChange("phoneNumber", e.target.value)
                  }
                  value={checkUndefine(supplier.phoneNumber)}
                />
              </FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6 m-0 p-0 pl-md-2">
              <FormWrapperInputComponent
                isValidation={true}
                dataValidation={supplier.taxNumber}
                validation={validation.taxNumber}
                labelTitle={t(`item.supplier.taxNumber`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`taxNumber`}
                  onChange={(e) =>
                    this.props.onChange("taxNumber", e.target.value)
                  }
                  value={checkUndefine(supplier.taxNumber)}
                />
              </FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6 m-0 p-0 pr-2">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.logoImage`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <UploadImage
                  multiple={false}
                  loading={this.state.isUploadingLogoImage}
                  thumbnailSize={120}
                  buttonSize={120}
                  thumbnailStyle={{ maxHeight: 200 }}
                  uploadText={t("item.supplier.uploadFile")}
                  loadingText={t("item.supplier.uploading")}
                  onChange={this.onUploadLogoImage}
                  onRemoveThumbnail={() => this.props.onChange("logoImage", undefined)}
                  thumbnails={
                    supplier.logoImage && this.getThumbSources([supplier.logoImage])
                  }
                />
              </FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-12 m-0 p-0">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.noteContent`)}
              >
                <RichTextEditor
                  editor={ClassicEditor}
                  data={supplier.noteContent || ""}
                  config={{ uploadDirectory: UPLOAD_DIRECTORY.IMAGES }}
                  onChange={(event, editor) => {
                    this.props.onChange("noteContent", editor.getData());
                  }}
                />
              </FormWrapperInputComponent>
            </Wrapper>
            {/* <Wrapper className="col-md-12 m-0 p-0">
                            <FormWrapperInputComponent
                                // isRequired={true}
                                // isValidation={true}
                                // dataValidation={supplier.supplierProduct}
                                // validation={validation.supplierProduct}
                                labelTitle={t(`item.supplier.supplierProduct`)}
                            >
                                <SupplierProducts supplierProducts={supplierProducts}
                                    loading={loadingProduct}
                                    selections={supplier.supplierProduct ? [supplier.supplierProduct] : []}
                                    onChange={this.onChangeSupplierProduct}
                                    onCreate={this.props.onCreateSupplierProduct}
                                    onUpdate={this.props.onUpdateSupplierProduct}
                                    onDelete={this.props.onDeleteSupplierProduct}
                                />
                            </FormWrapperInputComponent>
                        </Wrapper> */}
            {
              action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE ?
                <Wrapper className="col-12 m-0 p-3 m-b-imp border">
                  <div className="m-b-sm fw-500">FAQs</div>
                  <Wrapper className="col-12 m-0 p-3 border list-question">
                    {
                      supplierFAQs.filter(item => (item.languageCode === supplier.languageCode)).map((item) => {
                        return (
                          <Wrapper className="row m-b-xs">
                            <Wrapper className="col-10">
                              <Wrapper className="font-bold list-faqs-question">
                                {item.question}
                              </Wrapper>
                              <Wrapper>
                                {item.answer}
                              </Wrapper>
                            </Wrapper>
                            <Wrapper className="col-2 flex flex-center m-t">
                              <Icon type="delete" className="fs20 mr-1 cursorPointer" onClick={() => this.onClickDeleteFAQ(item.id)} />
                            </Wrapper>
                          </Wrapper>
                        )
                      }


                      )
                    }
                  </Wrapper>
                  <Wrapper className="flex flex-center justify-between m-0">
                    <Wrapper className="m-0 input-add-wrapper">
                      <Wrapper>
                        <div className='err-input-question'>{this.state.errorAddFAQs?.question}</div>
                        <Input
                          placeholder="Điền câu hỏi"
                          type={`text`}
                          className={`form-control no-borders border-bottom-imp col-6`}
                          name={`question`}
                          onChange={(e) =>
                            this.props.onChange("question", e.target.value)
                          }
                          value={checkUndefine(supplier.question)}
                        />
                      </Wrapper>
                      <Wrapper>
                        <div className='err-input-question'>{this.state.errorAddFAQs?.answer}</div>
                        <Input
                          placeholder="Điền câu trả lời"
                          type={`text`}
                          className={`form-control no-borders border-bottom-imp`}
                          name={`answer`}
                          onChange={(e) =>
                            this.props.onChange("answer", e.target.value)
                          }
                          value={checkUndefine(supplier.answer)}
                        />
                      </Wrapper>
                    </Wrapper>
                    <Wrapper className="m-0 button-add-faqs">
                      <Button type='button' className='btn btn-primary' onClick={this.onClickAddFAQs}>Thêm FAQs</Button>
                    </Wrapper>
                  </Wrapper>
                </Wrapper>
                : ''
            }

            <div className="col-12 row m-0 p-3 border">
              <Wrapper className="col-md-12 m-0 p-0">
                <FormWrapperInputComponent
                  labelTitle={t(`item.supplier.supplierSystem`)}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                >
                  <Switch
                    className="ml-2"
                    checked={supplier.isEnableVinwonder}
                    onChange={(checked) =>
                      this.props.onChange("isEnableVinwonder", checked)
                    }
                    checkedChildren="On"
                    unCheckedChildren="Off"
                    disabled={action !== DETAIL_ACTIONS.CREATE}
                  />
                  <AntSelect
                    className="select-types"
                    style={{ width: "100%" }}
                    value={this.state.supplierSystem}
                    disabled={!supplier.isEnableVinwonder}
                    onChange={(id) => this.setState({ supplierSystem: id })}
                  >
                    {this.getSupplierType().map((sp) => (
                      <AntOption key={sp.id} value={sp.id}>
                        {sp.label}
                      </AntOption>
                    ))}
                  </AntSelect>
                </FormWrapperInputComponent>
              </Wrapper>

              <Wrapper className="col-md-12 m-0 p-0">
                <FormWrapperInputComponent
                  isValidation={true}
                  dataValidation={supplier.siteCode}
                  validation={validation.siteCode}
                  visible={action !== DETAIL_ACTIONS.TRANSLATE}
                  labelTitle={""}
                >
                  <Popover
                    title={null}
                    content={this.state.siteCodePopoverContent}
                  >
                    <AntSelect
                      className="select-types"
                      showArrow
                      showSearch
                      name={`siteCode`}
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.select") +
                          " " +
                          t("item.supplier.siteCode")
                        ).toLowerCase()
                      )}
                      value={supplier.propertyCode}
                      filterOption={this.selectFilterSearchAnt}
                      onChange={(sp) => {
                        this.onChangeContentPopoverSiteCode(sp);
                      }}
                      style={{ width: "100%" }}
                      allowClear
                      disabled={!supplier.isEnableVinwonder}
                      dropdownClassName="site-code-selector"
                    >
                      {this.renderOptionsSiteSelect()}
                    </AntSelect>
                  </Popover>
                </FormWrapperInputComponent>
              </Wrapper>
            </div>
          </Wrapper>
        </FormWrapperItem>
        <div className="col-md-12 row m-0 p-0 pl-1 pr-1 mb-3">
          <Wrapper className="col-md-12 row m-0 p-0 pl-3 pr-3">
            <div className="col-12 row m-0 p-3 border">
              <FormWrapperInputComponent
                labelTitle={t(`item.supplier.titleLimitDateSearchTicket`)}
              >
                <Wrapper className="col-md-12 m-0 p-0">
                  <Radio.Group
                    value={supplier.saleDateType || ENUM_SUPPLIER_SALE_DATE_TYPE.NONE}
                    onChange={(e) => {
                      this.props.onChange("saleDateType", e.target.value);
                      this.props.onChange("saleDateValues", []);
                    }}
                  >
                    <Wrapper className="d-flex align-items-center">
                      <Radio key={SUPPLIER.SALE_DATE_TYPE.TYPE.MULTIPLE.data} value={ENUM_SUPPLIER_SALE_DATE_TYPE.MULTIPLE}>
                        {t(`item.supplier.multipleDate`)}
                      </Radio>
                      <Radio key={SUPPLIER.SALE_DATE_TYPE.TYPE.NONE.data} value={ENUM_SUPPLIER_SALE_DATE_TYPE.NONE}>
                        {t(`item.supplier.noneDate`)}
                      </Radio>
                    </Wrapper>
                    <Wrapper className="mt-2">
                      <Radio key={SUPPLIER.SALE_DATE_TYPE.TYPE.RANGE.data} value={ENUM_SUPPLIER_SALE_DATE_TYPE.RANGE}>
                        {t(`item.supplier.rangeDate`)}
                      </Radio>
                    </Wrapper>
                  </Radio.Group>
                  <br /><br />
                  {this.renderDatePicker()}
                </Wrapper>
              </FormWrapperInputComponent>
            </div>
          </Wrapper>
        </div>
        <Wrapper className="col-md-12 m-0 p-0 pr-3 pl-3 mt-3">
          <FormWrapperInputComponent
            labelTitle="Thời gian mở bán"
            visible={action !== DETAIL_ACTIONS.TRANSLATE}
          >
            <DatePickerComponent
              className="form-control applyDates w100-percent"
              hmsComponent="DatePicker"
              format={DATE_TIME_FORMAT.DATE_TIME}
              showTime={{ format: DATE_TIME_FORMAT.SHORT_TIME }}
              style={{ padding: 0, border: 0 }}
              name="saleStartDate"
              placeholder="Chọn thời gian mở bán"
              value={supplier.saleStartDate}
              onChange={(data) => this.props.onChange("saleStartDate", data.fullValue)}
            />
          </FormWrapperInputComponent>
        </Wrapper>
        <Wrapper className="col-md-12 m-0 p-0 pr-3 pl-3 mt-3">
          <FormWrapperInputComponent
            labelTitle={"Khách sạn"}
            visible={action !== DETAIL_ACTIONS.TRANSLATE}
          >
            <AntSelect
              className="select-types"
              style={{ width: "100%" }}
              name={`fnbPropertyId`}
              placeholder="Chọn khách sạn"
              value={supplier.fnbPropertyId}
              showSearch
              filterOption={this.selectFilterSearchAnt}
              onChange={(id) => this.props.onChange("fnbPropertyId", id)}
              allowClear
            >
              {(fnbProperties || []).map((property) => (
                <AntOption key={property.id} value={property.id}>
                  {property.name}
                </AntOption>
              ))}
            </AntSelect>
          </FormWrapperInputComponent>
        </Wrapper>
      </Wrapper>
    );
  }
  onSelectDateRange = (data) => {
    if (this.props.onChange) {
      this.props.onChange("saleDateValues", data.fullValue);
    }
  }

  getThumbSources(thumbs) {
    return (thumbs || []).map((t) => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t}`);
  }

  onChangeSupplierProduct = (id) => {
    const { supplierProducts } = this.props;
    const supplierProduct = find(supplierProducts, (t) => t.id === id);

    return this.props.onChange("supplierProduct", supplierProduct);
  };

  onUploadLogoImage = (file) => {
    const fileData = file.target.files[0];
    const imageValidation = ["image/jpeg", "image/jpg", "image/png"];

    if (!fileData) {
      return;
    }

    if (!imageValidation.includes(fileData.type)) {
      message.error(this.props.t("validation.image"));
      return;
    }

    this.setState({ isUploadingLogoImage: true });
    this.props.onUploadFile({
      file: fileData,
      directory: UPLOAD_DIRECTORY.IMAGES,
      isFile: 1,
      field: "logoImage",
      onUploaded: () => this.setState({ isUploadingLogoImage: false }),
    });
  };

  onClickAddFAQs = () => {
    const { supplier } = this.props;
    let error = { isError: false };
    if (!supplier.question) {
      error.question = "* Câu hỏi không được để trống";
      error.isError = true;
    }
    if (!supplier.answer) {
      error.answer = "* Câu trả lời không được để trống";
      error.isError = true;
    }
    if (error?.isError) {
      this.setState({ errorAddFAQs: error });
    } else {
      const supplierFAQs = {
        "supplierId": `${supplier?.id}`,
        "question": `${supplier.question}`,
        "answer": `${supplier.answer}`,
        "languageCode": `${supplier.languageCode}`
      }
      this.props.createSupplierFAQs(supplierFAQs, {
        onSuccess: () => {
          supplier.question = ''
          supplier.answer = ''
          this.setState({ errorAddFAQs: { question: '', answer: '', addFAQs: [] } })
        }
      })
    }
  };

  onClickDeleteFAQ = (id) => {
    this.props.deleteSupplierFAQs(id, this.props.supplier.id);
  };
}

SupplierInfo.defaultProps = {
  loadingProduct: false,
  supplierProducts: [],
  onChange: () => { },
  onUploadFile: () => { },
};
